module.exports = __webpack_public_path__ + "img/filter-matches.a2863e8a.png";